import { css } from "styled-components";
export const riotProductSkin = (chroma, paletteTokens) => css `
  --checkbox-border-size: 4px;

  && {
    all: unset;
    color: ${chroma.input.foregroundDisabled};
    background-color: transparent;
    width: 40px;
    min-width: 40px;
    height: 40px;
    box-sizing: border-box;
    border: var(--checkbox-border-size) solid ${paletteTokens.bladetext1};
  }

  &:focus {
    outline: none;
  }

  .icon {
    color: ${paletteTokens.bladetext1};
    display: block;
    margin: auto;
    width: calc(100% - var(--checkbox-border-size) * 2);
  }
`;
//# sourceMappingURL=index.js.map